import { StylesConfig } from "react-select";

export const selectStyles: StylesConfig = {
  control: (styles) => ({ ...styles, height: "100%" }),
  placeholder: (styles) => ({
    ...styles,
    color: "#11204d",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#11204d",
  }),
  option: (styles, { isSelected }) => {
    return {
      ...styles,
      color: isSelected ? "#11204d" : "#11204d",
    };
  },
  indicatorsContainer: (styles) => ({
    ...styles,
    color: "#11204d",
  }),
  menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
};

export const toastStyles = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
